<template>
  <nav class="border-t-2 border-black flex justify-between items-center">
    <!-- Previous Link -->
    <button
      :disabled="!hasPreviousPages"
      class="btn btn-link py-3 "
      :class="{
                'text-primary dim': hasPreviousPages,
                'text-80 opacity-50': !hasPreviousPages,
            }"
      rel="prev"
      dusk="previous"
      @click.prevent="selectPreviousPage()"
    >
      {{ $t('Previous') }}
    </button>

    <slot></slot>

    <!-- Next Link -->
    <button
      :disabled="!hasMorePages"
      class="btn btn-link py-3 "
      :class="{
                'text-primary dim': hasMorePages,
                'text-80 opacity-50': !hasMorePages,
            }"
      rel="next"
      dusk="next"
      @click.prevent="selectNextPage()"
    >
      {{ $t('Next') }}
    </button>
  </nav>
</template>

<script>
  export default {
    props: {
      hasPreviousPages: {
        type: Boolean,
        default: false,
      },
      hasMorePages: {
        type: Boolean,
        default: false,
      },
    },

    methods: {
      /**
       * Select the previous page.
       */
      selectPreviousPage() {
        if (this.hasPreviousPages) {
          this.$emit('previous');
        }
      },

      /**
       * Select the next page.
       */
      selectNextPage() {
        if (this.hasMorePages) {
          this.$emit('next');
        }
      },
    },
  };
</script>
